module.exports = __webpack_public_path__ + "img/topic3.c5438ca8.png";